import { z } from "zod/v4";

import { ActiveStripeSubscriptionDtoSchema } from "../../../dtos/stripe-subscription-links";

export const GetActiveSubscriptionsResponseBodySchema = z.object({
  activeSubscriptions: ActiveStripeSubscriptionDtoSchema.array(),
});

export type GetSubscriptionsResponseBodyType = z.infer<
  typeof GetActiveSubscriptionsResponseBodySchema
>;
